import { useMutation } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { abortExportInputValuesJob } from '@app/store/transport-layer/document/export-input-values-jobs/abort';

export default function useAbortExportInputValuesJob({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (errorMessage: string) => void;
}) {
  const workspaceId = useWorkspaceId();

  return useMutation({
    mutationFn: (jobId: string) => abortExportInputValuesJob({ jobId, workspaceId }),
    onSuccess,
    onError,
  });
}
